import React from 'react'
import clsx from 'clsx'

import MediaAvatar from '../../../../../atoms/MediaAvatar'

import { useInView } from 'react-hook-inview'
import useStyles from './styles'

const Result = ({ user }) => {
  const [inViewRef, inView] = useInView({
    root: document.querySelector('#edit-search-results')
  })

  const classes = useStyles()

  return (
    <div ref={inViewRef} className={classes.root}>
      {inView ? (
        <>
          <div className={classes.avatarArea}>
            <MediaAvatar user={user} className={classes.avatar} />
          </div>

          <div className={classes.name}>{user.name}</div>
        </>
      ) : (
        <>
          <div className={classes.avatarArea}>
            <div className={clsx(classes.avatar, classes.mockAvatar)} />
          </div>

          <div className={classes.mockName} />
        </>
      )}
    </div>
  )
}

export default Result
